import { render, staticRenderFns } from "@/modules/ThirdParty/templates/third-party-list.html?vue&type=template&id=17ecb0d4&scoped=true&"
import script from "@/modules/ThirdParty/scripts/third-party-list.ts?vue&type=script&lang=js&"
export * from "@/modules/ThirdParty/scripts/third-party-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/ThirdParty/styles/third-party-list.scss?vue&type=style&index=0&id=17ecb0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ecb0d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
